import { motion } from "framer-motion";
import { X, Stack, Eye } from "@phosphor-icons/react";

export default function MultiLayerPanel({ layers, layerStates, onChange, onClose }) {
  const handleToggle = (id) => {
    onChange({ ...layerStates, [id]: { ...layerStates[id], enabled: !layerStates[id].enabled } });
  };

  const handleOpacity = (id, val) => {
    onChange({ ...layerStates, [id]: { ...layerStates[id], opacity: val / 100 } });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.15 }}
      className="absolute top-full right-0 mt-2 w-80 bg-stone-900 border border-stone-700 rounded-xl shadow-2xl overflow-hidden z-[1100]"
      data-testid="multi-layer-panel"
    >
      <div className="px-4 py-3 border-b border-stone-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Stack size={16} weight="bold" className="text-emerald-400" />
          <span className="text-sm font-heading text-white">Map Layers</span>
        </div>
        <button
          onClick={onClose}
          className="text-stone-400 hover:text-white p-0.5 rounded"
          data-testid="layer-panel-close"
        >
          <X size={14} />
        </button>
      </div>

      <div className="p-3 space-y-1">
        {layers.map((layer) => {
          const state = layerStates[layer.id];
          const LayerIcon = layer.Icon;
          return (
            <div key={layer.id} className="rounded-lg hover:bg-stone-800/50 transition-colors p-2">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={state.enabled}
                  onChange={() => handleToggle(layer.id)}
                  className="w-4 h-4 rounded border-stone-600 bg-stone-800 accent-emerald-500 cursor-pointer"
                  data-testid={`layer-toggle-${layer.id}`}
                />
                <div className={`w-7 h-7 rounded-lg ${layer.accentBg} flex items-center justify-center`}>
                  <LayerIcon
                    size={14}
                    weight="bold"
                    className={state.enabled ? layer.accent : "text-stone-600"}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-body ${state.enabled ? "text-white" : "text-stone-500"}`}>
                    {layer.name}
                  </p>
                  <p className="text-[10px] text-stone-600">{layer.description}</p>
                </div>
                {state.enabled && (
                  <Eye size={14} className="text-emerald-400 shrink-0" />
                )}
              </label>

              {state.enabled && (
                <div className="mt-2 ml-10 flex items-center gap-2">
                  <span className="text-[10px] text-stone-500 w-12">Opacity</span>
                  <input
                    type="range"
                    min={10}
                    max={100}
                    value={Math.round(state.opacity * 100)}
                    onChange={(e) => handleOpacity(layer.id, parseInt(e.target.value, 10))}
                    className="flex-1 h-1 rounded-full appearance-none bg-stone-700 accent-emerald-500 cursor-pointer"
                    data-testid={`layer-opacity-${layer.id}`}
                  />
                  <span className="text-[10px] text-stone-500 font-mono w-8 text-right">
                    {Math.round(state.opacity * 100)}%
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
